'use strict';

exports.__esModule = true;
var SETTINGS = exports.SETTINGS = {
  TWITTER_ENABLED: 'twitter_enabled'
};